<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>{{ $t('message.notificacion') }} - {{ number }}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12">
        <input-field
          @keyup.enter="aceptar"
          :id="'mensaje' + id"
          v-model="motivo"
          placeholder="Escriba un mensaje..."
        >Motivo</input-field>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="aceptar" class="btn-success" type="button">
        <i class="fa fa-check"></i>
        <span>Aceptar</span>
      </button>
      <button @click="$emit('cancelar')" class="btn-danger" type="button">
        <i class="fa fa-ban"></i>
        <span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      required: true
    },
    number: {
      type: String,
      required: true
    }
  },
  methods: {
    aceptar: function() {
      if (this.motivo !== "") this.$emit("motivo", this.motivo);
      else swal("El motivo es requerido.", "Aviso", "warning");
    }
  },
  data: function() {
    return {
      motivo: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/inspeccion/NotificacionProceso.vue